<template>
<div class="svg-animated">

  <svg class="el" version="1.1" id="Ebene_20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 373.7 373.7" style="enable-background:new 0 0 373.7 373.7;" xml:space="preserve">

  <g class="svg-circle">
  	<defs>
  		<polyline id="SVGID_1_0" points="347.5,347.3 347.5,26.2 26.3,26.2 26.3,347.3 		"/>
  	</defs>
  	<clipPath id="SVGID_2_0">
  		<use xlink:href="#SVGID_1_1"  style="overflow:visible;"/>
  	</clipPath>
  	<path class="st0 p0 " d="M187.3,158.3 M186.9,315c-21.7,0-39.4-17.7-39.4-39.4s17.7-39.4,39.4-39.4c21.3,0,38.6-17.3,38.6-38.6
  		S208.2,159,186.9,159l-0.4,0c-21.5-0.2-39-17.8-39-39.4c0-21.7,17.7-39.4,39.4-39.4c64.7,0,117.4,52.7,117.4,117.4
  		S251.6,315,186.9,315"/>
  </g>
  </svg>

  <svg class="el" version="1.1" id="Ebene_21" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 373.7 373.7" style="enable-background:new 0 0 373.7 373.7;" xml:space="preserve">

    <g class="svg-circle">
    	<defs>
    		<polyline id="SVGID_1_1" points="347.5,347.3 347.5,26.2 26.3,26.2 26.3,347.3 		"/>
    	</defs>
    	<clipPath id="SVGID_2_1">
    		<use xlink:href="#SVGID_1_1"  style="overflow:visible;"/>
    	</clipPath>
    	<path class="st0 p1 " d="M186.5,146.1 M186.9,302.8c-64.7,0-117.4-52.7-117.4-117.4S122.2,68.1,186.9,68.1l0.4,0
    		c21.5,0.2,39,17.8,39,39.4s-17.5,39.2-39,39.4v0l-0.4,0c-21.3,0-38.6,17.3-38.6,38.6s17.3,38.6,38.6,38.6l0.4,0
    		c21.5,0.2,39,17.8,39,39.4C226.3,285.2,208.6,302.8,186.9,302.8"/>

    </g>
    </svg>

  <svg class="el" version="1.1" id="Ebene_22" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 373.7 373.7" style="enable-background:new 0 0 373.7 373.7;" xml:space="preserve">

      <g class="svg-circle">
      	<defs>
      		<polyline id="SVGID_1_2" points="347.5,347.3 347.5,26.2 26.3,26.2 26.3,347.3 		"/>
      	</defs>
      	<clipPath id="SVGID_2_2">
      		<use xlink:href="#SVGID_1_2"  style="overflow:visible;"/>
      	</clipPath>
      	<path class="st0 p2 " d="M220.2,217.5c-6.9-11.8-19.7-19.1-33.3-19.1c-21.3,0-38.6,17.3-38.6,38.6c0,21.3,17.3,38.6,38.6,38.6
      		c42.8,0,77.6-34.8,77.6-77.6s-34.8-77.6-77.6-77.6c-21.7,0-39.4-17.7-39.4-39.4s17.7-39.4,39.4-39.4l0.1,0h0.1
      		c32.2,0,62.7,10.3,88.3,29.9c24.8,19,43.1,45.8,51.6,75.6"/>

      </g>
      </svg>

  <svg class="el" version="1.1" id="Ebene_23" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 373.7 373.7" style="enable-background:new 0 0 373.7 373.7;" xml:space="preserve">

        <g class="svg-circle">
        	<defs>
        		<polyline id="SVGID_1_3" points="347.5,347.3 347.5,26.2 26.3,26.2 26.3,347.3 		"/>
        	</defs>
        	<clipPath id="SVGID_2_3">
        		<use xlink:href="#SVGID_1_3"  style="overflow:visible;"/>
        	</clipPath>
        	<path class="st0 p3 " d="M186.9,27C98.8,27,27.1,98.7,27.1,186.8c0,88.1,71.7,159.8,159.8,159.8s159.8-71.7,159.8-159.8
        		c0-10.4-1-20.8-3-31"/>
        </g>
        </svg>
</div>
</template>

<script>
import anime from 'animejs';

export default {
  name: 'svg-circle',
  mounted() {
    this.$nextTick(() => {
      // put code here
      anime({
        targets: '.el',
        // filter: ["blur(5px)", "blur(0px)"],
        // translateZ: [-200, 0],
        opacity: [0, 1],
        easing: 'easeInQuad',
        // easing: 'spring(1, 80, 10, 0)',

        duration: 1500,
        // delay: 30000,

        delay: anime.stagger(300), // increase delay by 100ms for each elements.

      });


    })


    // anime({
    //   targets: ['.p2'],
    //   strokeDashoffset: [0, anime.setDashoffset],
    //   easing: 'easeInOutSine',
    //   duration: 6000,
    //   delay: 550,
    //   direction: 'alternate',
    //   loop: true,
    // });
    anime({
      targets: ['.p2', '.p0', '.p1'],
      strokeDashoffset: [anime.setDashoffset, 0],
      easing: 'easeOutQuart',
      duration: 5000,
      delay: 250,
      direction: 'alternate',
      loop: true,
    });
  }
}
</script>

<style>
.el {
  /* filter: blur(20px); */
  /* transform: translateZ(0px) rotateZ(0); */
  /* opacity: 0; */
  will-change: transform;
  perspective: 800;

}

.p1,
.p2,
.p0 {
  will-change: stroke-dash-offset;
}

.svg-animated svg {
  position: absolute;
  max-height: 375px;
}

@-webkit-keyframes rotation {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(359deg);
  }
}

.p3 {
  animation: rotation 12s reverse infinite linear
}

.svg-text-outer {
  animation: rotation 24s infinite linear
}

.st0 {
  clip-path: url(#SVGID_2_);
  fill: none;
  stroke: #00FF00;
  stroke-miterlimit: 10;
  transform-origin: 50% 50%;
  /* stroke-dasharray: 200; */
}

.p2 {
  /* stroke-dasharray: 200;
  animation: dash 6s infinite; */
}

.p1 {
  /* stroke-dasharray: 200;
  animation: dash 12s alternate infinite; */
}

svg {
  perspective: 800;
}

path {
  /* stroke-dasharray: 200; */
  /* animation: dash 5s ease alternate infinite; */
}

@keyframes dash {
  to {
    stroke-dashoffset: 1000;
  }
}
</style>
